import { render, staticRenderFns } from "./ProductsOrders.vue?vue&type=template&id=4ac558b8"
import script from "./ProductsOrders.vue?vue&type=script&lang=js"
export * from "./ProductsOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports